import { Badge } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import { rowCard, title } from '@mage-ui/styled-system/recipes';
import { BubblePlaceholder } from '../../images/bubble-placeholder/BubblePlaceholder';
import { ImageRound } from '../../images/image-round/ImageRound';
import { RoundPlaceholder } from '../../images/round-placeholder/RoundPlaceholder';

// MiniCardItem
export const RowCard = ({ data, ...props }) => {
  return (
    <div className={rowCard().root} {...props}>
      <div className={rowCard().imageWrapper}>
        {data.img_mini_card !== undefined ? (
          <ImageRound
            src={data.img_mini_card}
            alt={data.alt_img ?? data.title}
            sizes={{ width: 75, height: 75 }}
            className={rowCard().image}
          />
        ) : data.title ? (
          <BubblePlaceholder title={data.title} />
        ) : (
          <RoundPlaceholder texts={{ a11yText: data.placeholder }} />
        )}
        {data.label && <Badge className={rowCard().label}>{data.label}</Badge>}
      </div>

      <h3 className={cx(title({ size: '4', weight: 'bold' }), rowCard().title)}>
        {data.title}
      </h3>
    </div>
  );
};
